import type { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import useAccess from '@/hooks/useAccess';

interface Props {
  redirectTo?: string;
}

const CaptaGuard: FC<Props> = ({ redirectTo = '..' }) => {
  const { isCaptaUser } = useAccess();

  if (!isCaptaUser) {
    return <Navigate to={redirectTo} replace />;
  }

  return <Outlet />;
};

export default CaptaGuard;
